import { Box, styled } from '@mui/material';

const LargerInputContainer = styled(Box)({
    gridColumn: '1 / -1'
});

export default LargerInputContainer;
